import React from "react";
import { Pill, PillWrapper } from "../../../designSystem/pill/Pill";

type IndicatorListProps = {
    indicators: string[]
}

export function IndicatorList(props: IndicatorListProps): JSX.Element {
    return (
        <PillWrapper>
            {props.indicators.map((v, i) =>
                <Pill fontSize="12" horizontalPadding={8} verticalPadding={0} key={i} identifier={`${i}`}>{v}</Pill>
            )}
        </PillWrapper>
    );
}